// extracted by mini-css-extract-plugin
export default {"SearchResultMap":"SearchResultMap_SearchResultMap__hv5M8"};